export default __webpack_public_path__ + "static/media/newstab_banner.426ffa43.png";